import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-100 row g-0 mb-2" }
const _hoisted_2 = {
  key: 0,
  class: "col-12 col-lg-4 pe-lg-2 form-group d-flex flex-column"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "facility-name" }, " Facility Name ", -1 /* HOISTED */)
const _hoisted_4 = { class: "col-12 col-lg-4 pe-lg-2 form-group" }
const _hoisted_5 = { for: "country" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Country ")
const _hoisted_7 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_8 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_10 = { class: "col-12 col-lg-4 pe-lg-2 form-group" }
const _hoisted_11 = { for: "referral-address-line-1" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Address Line 1 ")
const _hoisted_13 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_14 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_15 = { class: "col-12 col-lg-4 pe-lg-2 form-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "referral-address-line-2" }, " Address Line 2 ", -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_18 = { class: "col-12 col-lg-2 pe-lg-2 form-group" }
const _hoisted_19 = { for: "referral-city" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" City ")
const _hoisted_21 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_24 = { class: "col-12 col-lg-2 pe-lg-2 form-group" }
const _hoisted_25 = { for: "referral-state" }
const _hoisted_26 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 2,
  class: "field-invalid"
}
const _hoisted_29 = { class: "col-12 col-lg-2 pe-lg-2 form-group" }
const _hoisted_30 = { for: "referral-zip" }
const _hoisted_31 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_32 = ["value", "disabled"]
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 2,
  class: "field-invalid"
}
const _hoisted_35 = { class: "col-12 col-lg-2 pe-lg-2 form-group" }
const _hoisted_36 = { for: "referral-county" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" County ")
const _hoisted_38 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_39 = {
  key: 1,
  class: "form-group row col-12"
}
const _hoisted_40 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  for: "date-of-movein",
  id: "Referral_Date_Of_Birth_Label"
}, " Move-in Date ", -1 /* HOISTED */)
const _hoisted_42 = { class: "input-group date datepickerInput" }
const _hoisted_43 = ["value"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_45 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", {
  for: "date-of-moveout",
  id: "Referral_Date_Of_Birth_Label"
}, " Move-out Date ", -1 /* HOISTED */)
const _hoisted_47 = { class: "input-group date datepickerInput" }
const _hoisted_48 = ["value"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_CountryTypeahead = _resolveComponent("CountryTypeahead")!
  const _component_PlacesAutocomplete = _resolveComponent("PlacesAutocomplete")!
  const _component_StateTypeahead = _resolveComponent("StateTypeahead")!
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isFacility)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_TypeaheadInput, {
            id: "facility-name",
            getData: _ctx.getVendorList,
            value: _ctx.selectedFacility,
            onValueChanged: _ctx.updateFacility,
            "init-value": _ctx.selectedFacility,
            placeholder: "Start Typing..."
          }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, [
        _hoisted_6,
        (_ctx.isRequired)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "*"))
          : _createCommentVNode("v-if", true)
      ]),
      _createVNode(_component_CountryTypeahead, {
        id: "country",
        updateSelectedCountry: _ctx.updateSelectedCountry,
        "prefill-country": _ctx.address.country,
        disabled: _ctx.isFacilitySelected,
        onBlurredInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.v$.address.country.$touch())),
        onChange: _cache[1] || (_cache[1] = (e) => _ctx.handleAllInputChange('country', _ctx.address.country))
      }, null, 8 /* PROPS */, ["updateSelectedCountry", "prefill-country", "disabled"]),
      (_ctx.v$.address.country.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Country is required."))
        : _createCommentVNode("v-if", true)
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("label", _hoisted_11, [
        _hoisted_12,
        (_ctx.isRequired)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "*"))
          : _createCommentVNode("v-if", true)
      ]),
      _createVNode(_component_PlacesAutocomplete, {
        id: "referral-address-line-1",
        street: _ctx.address.addressLine1,
        "onUpdate:street": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.address.addressLine1) = $event)),
        city: _ctx.address.city,
        "onUpdate:city": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.address.city) = $event)),
        state: _ctx.address.state,
        "onUpdate:state": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.address.state) = $event)),
        zip: _ctx.address.zipCode,
        "onUpdate:zip": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.address.zipCode) = $event)),
        county: _ctx.address.county,
        "onUpdate:county": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.address.county) = $event)),
        latitude: _ctx.address.latitude,
        "onUpdate:latitude": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.address.latitude) = $event)),
        longitude: _ctx.address.longitude,
        "onUpdate:longitude": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.address.longitude) = $event)),
        disabled: _ctx.isFacilitySelected,
        "onUpdate:disabled": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isFacilitySelected) = $event)),
        country: _ctx.autoCompleteCountry,
        "onUpdate:country": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.autoCompleteCountry) = $event)),
        "places-changed-call-back": _ctx.placesChangedCallBack,
        onBlurredInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.address.addressLine1.$touch())),
        onChange: _cache[12] || (_cache[12] = (e) => _ctx.handleAllInputChange('addressLine1', _ctx.address.addressLine1))
      }, null, 8 /* PROPS */, ["street", "city", "state", "zip", "county", "latitude", "longitude", "disabled", "country", "places-changed-call-back"]),
      (_ctx.v$.address.addressLine1.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Address Line 1 is required."))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        maxlength: "50",
        type: "text",
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.address.addressLine2) = $event)),
        placeholder: "Enter Address Line 2"
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, _ctx.address.addressLine2]
      ])
    ]),
    _hoisted_17,
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("label", _hoisted_19, [
        _hoisted_20,
        (_ctx.isRequired)
          ? (_openBlock(), _createElementBlock("span", _hoisted_21, "*"))
          : _createCommentVNode("v-if", true)
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        maxlength: "50",
        type: "text",
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.address.city) = $event)),
        placeholder: "Enter City",
        disabled: _ctx.isFacilitySelected,
        onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.v$.address.city.$touch())),
        onChange: _cache[16] || (_cache[16] = (e) => _ctx.handleAllInputChange('city', _ctx.address.city))
      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_22), [
        [_vModelText, _ctx.address.city]
      ]),
      (_ctx.v$.address.city.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_23, "City is required."))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("label", _hoisted_25, [
        _createTextVNode(_toDisplayString(_ctx.isUnitedStates ? "State" : "State / Province / Territory") + " ", 1 /* TEXT */),
        (_ctx.isRequired)
          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "*"))
          : _createCommentVNode("v-if", true)
      ]),
      (_ctx.isUnitedStates)
        ? (_openBlock(), _createBlock(_component_StateTypeahead, {
            key: 0,
            "selected-state": _ctx.selectedState,
            "onUpdate:selected-state": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selectedState) = $event)),
            "prefill-state": _ctx.address.state,
            "onUpdate:prefill-state": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.address.state) = $event)),
            disabled: _ctx.isFacilitySelected,
            onBlurredInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.v$.address.state.$touch())),
            onChange: _cache[20] || (_cache[20] = (e) => _ctx.handleAllInputChange('state', e.target.value))
          }, null, 8 /* PROPS */, ["selected-state", "prefill-state", "disabled"]))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: "form-control",
            maxlength: "50",
            type: "text",
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.address.state) = $event)),
            placeholder: "Enter State / Province / Territory",
            disabled: _ctx.isFacilitySelected,
            onBlur: _cache[22] || (_cache[22] = ($event: any) => (_ctx.v$.address.state.$touch())),
            onChange: _cache[23] || (_cache[23] = (e) => _ctx.handleAllInputChange('state', _ctx.address.state))
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_27)), [
            [_vModelText, _ctx.address.state]
          ]),
      (_ctx.v$.address.state.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_28, "State is required."))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("label", _hoisted_30, [
        _createTextVNode(_toDisplayString(_ctx.isUnitedStates ? "ZIP" : "Postal Code") + " ", 1 /* TEXT */),
        (_ctx.isRequired)
          ? (_openBlock(), _createElementBlock("span", _hoisted_31, "*"))
          : _createCommentVNode("v-if", true)
      ]),
      (_ctx.isUnitedStates)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            class: "form-control",
            maxlength: "10",
            type: "text",
            "number-only": "",
            value: _ctx.formatZipCode(_ctx.address.zipCode),
            onChange: _cache[24] || (_cache[24] = (e) => _ctx.handleZipcodeChange(e)),
            placeholder: "Enter Zip",
            disabled: _ctx.isFacilitySelected,
            onBlur: _cache[25] || (_cache[25] = ($event: any) => (_ctx.v$.address.zipCode.$touch()))
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_32))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: "form-control",
            maxlength: "50",
            type: "text",
            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.address.zipCode) = $event)),
            placeholder: "Enter Postal Code",
            disabled: _ctx.isFacilitySelected,
            onBlur: _cache[27] || (_cache[27] = ($event: any) => (_ctx.v$.address.zipCode.$touch())),
            onChange: _cache[28] || (_cache[28] = (e) => _ctx.handleAllInputChange('zipCode', _ctx.address.zipCode))
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_33)), [
            [_vModelText, _ctx.address.zipCode]
          ]),
      (_ctx.v$.address.zipCode.$error)
        ? (_openBlock(), _createElementBlock("span", _hoisted_34, "ZIP is required."))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("label", _hoisted_36, [
        _hoisted_37,
        (_ctx.isUnitedStates && _ctx.isRequired)
          ? (_openBlock(), _createElementBlock("span", _hoisted_38, "*"))
          : _createCommentVNode("v-if", true)
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        maxlength: "50",
        type: "text",
        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.address.county) = $event)),
        placeholder: "Enter County"
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, _ctx.address.county]
      ])
    ]),
    (_ctx.showMoveDate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createVNode(_component_DatePicker, {
              options: _ctx.datePickerOptions,
              getDate: _ctx.handleDateChange
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("input", {
                    name: "moveInDate",
                    id: "Movein_Date",
                    type: "text",
                    class: "form-control",
                    placeholder: "MM/DD/YYYY",
                    value: _ctx.formatDateInput(_ctx.address.moveInDate),
                    autocomplete: "off",
                    "date-format-only": "",
                    onChange: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.onDateInputChange && _ctx.onDateInputChange(...args)))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_43),
                  _hoisted_44
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["options", "getDate"])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _hoisted_46,
            _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("input", {
                    name: "moveOutDate",
                    id: "Moveout_Date",
                    type: "text",
                    class: "form-control",
                    placeholder: "MM/DD/YYYY",
                    value: _ctx.formatDateInput(_ctx.address.moveOutDate),
                    autocomplete: "off",
                    "date-format-only": "",
                    onChange: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.onDateInputChange && _ctx.onDateInputChange(...args)))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_48),
                  _hoisted_49
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["getDate"])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}